export default "__VITE_ASSET__koTSqiHv__"